import { render, staticRenderFns } from "./StockBrowse.vue?vue&type=template&id=3a4d397d"
import script from "./StockBrowse.vue?vue&type=script&lang=ts"
export * from "./StockBrowse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4d397d')) {
      api.createRecord('3a4d397d', component.options)
    } else {
      api.reload('3a4d397d', component.options)
    }
    module.hot.accept("./StockBrowse.vue?vue&type=template&id=3a4d397d", function () {
      api.rerender('3a4d397d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stock/StockBrowse.vue"
export default component.exports